import { Injectable } from '@angular/core'
import { MatSidenav } from '@angular/material/sidenav'

@Injectable()
export class NavService {
  private sidenav?: MatSidenav

  register(sidenav: MatSidenav): void {
    this.sidenav = sidenav
  }

  close(): void {
    this.sidenav?.close()
  }

  open(): void {
    this.sidenav?.open()
  }
}
